import React, { FC, useCallback, useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core';
import { MdContentCopy as CopyIcon } from '@react-icons/all-files/md/MdContentCopy';
import { SITE_URL } from 'src/env';
import { useNotifier } from 'src/components/NotificationCenter/AlertNotificationCenter';
import useTicket from 'src/hooks/api/useTicket';
import ProviderSelect from 'src/components/ApiField/ProviderSelect';

interface Props {
  ticketId: string;
  open: boolean;
  onClose: () => void;
}

const ExternalLinkDialog: FC<Props> = ({ ticketId, open, onClose }) => {
  const { addNotification } = useNotifier();

  const [providerId, setProviderId] = useState<string>();
  const [interventionOrderToken, setInterventionOrderToken] = useState<string>();
  const { getInterventionOrderToken } = useTicket();

  useEffect(() => {
    if (open && providerId) {
      (async () => {
        const interventionOrderToken = await getInterventionOrderToken(ticketId, providerId);
        setInterventionOrderToken(interventionOrderToken);
      })();
    }
  }, [ticketId, providerId, open]);

  const getProviderLink = useCallback((): string => {
    return `${SITE_URL}/intervention-order?token=${interventionOrderToken}`;
  }, [interventionOrderToken]);

  const copyProviderLinkToClipboard = useCallback(() => {
    navigator.clipboard.writeText(getProviderLink());
    addNotification({
      title: 'Lien copié dans le presse-papier !',
      alertProps: { color: 'success' },
    });
  }, [getProviderLink]);

  return (
    <Dialog open={open} onClose={onClose} scroll='paper'>
      <DialogTitle>Lien de partage</DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            Lien de partage pour les prestataires externes.
          </Grid>

          <Grid item xs={12}>
            <ProviderSelect value={providerId} onChange={setProviderId} />
          </Grid>

          <Grid item xs={12}>
            {providerId && interventionOrderToken && (
              <>
                <TextField
                  label="Création du bon d'intervention"
                  value={getProviderLink()}
                  onChange={undefined}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <IconButton onClick={copyProviderLinkToClipboard}>
                          <CopyIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <Typography variant='caption'>Le lien est valable 14 jours.</Typography>
              </>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary'>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExternalLinkDialog;
